import { Button } from 'components/common'

type Props = {
  buttonText?: string
  loading?: boolean
}

/**
 * Shared footer + submit button for the forms inside the order Reports modal,
 * so every report tab ends with the same right-aligned, low-emphasis action
 */
const ReportSubmitButton = ({ buttonText = 'Generate', loading }: Props) => {
  return (
    <div className="mt-2 flex justify-end border-t border-gray-100 pt-4">
      <Button
        type="submit"
        variant="custom"
        buttonText={buttonText}
        loading={loading}
        disabled={loading}
        className="min-w-[110px] rounded-lg bg-gray-100 px-4 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-60"
      />
    </div>
  )
}

export default ReportSubmitButton
